import { Link } from "react-router-dom";
import { fmtMoney, pickPhoto, photoSrcSet, primaryPhoto } from "../lib/usePublicSettings";

import { tr, lbl } from "../lib/i18n";
export default function VehicleCard({ v, settings }) {
  const photo = pickPhoto(v, "thumbnail");
  const price = v.public_price != null ? fmtMoney(v.public_price, settings) : tr("x.price_on_request");
  return (
    <Link
      to={`/cars/${v.stock_number}`}
      className="vcard"
      data-testid={`vcard-${v.stock_number}`}
    >
      <div className="vcard-img">
        {photo ? (
          <img src={photo} {...photoSrcSet(primaryPhoto(v))} width={400} height={300} alt={`${v.make} ${v.model}`} loading="lazy" decoding="async" />
        ) : (
          <div className="vcard-placeholder" data-testid={`vcard-placeholder-${v.stock_number}`}>{tr("x.no_photo")}</div>
        )}
        <div className="vcard-badges">
          {v.status === "Reserved" ? <span className="vbadge reserved">{tr("x.reserved")}</span> : null}
          {v.specification ? <span className="vbadge">{lbl(v.specification)}</span> : null}
        </div>
      </div>
      <div className="vcard-body">
        <div className="vcard-title">
          {v.make} {v.model} <span style={{ color: "var(--pub-muted)", fontWeight: 500 }}>{v.model_year}</span>
        </div>
        <div className="vcard-meta">
          <span>{(v.mileage || 0).toLocaleString()} {tr("x.km_unit")}</span>
          {v.transmission ? <span>· {lbl(v.transmission)}</span> : null}
          {v.fuel_type ? <span>· {lbl(v.fuel_type)}</span> : null}
        </div>
        <div className={`vcard-price ${v.public_price == null ? "small" : ""}`}>{price}</div>
      </div>
    </Link>
  );
}
